import React, { Component} from "react";
import { Link } from "react-router";
import PaypalModule from "../pages/games_account/PaypalModule";
const CONTROLS_STATE = {
  NONE                : 0,
  UPDATE_PREFERENCES  : 1,
  MANAGE_SUBSCRIPTION : 2,
  ORDER_PREMIUM       : 3,
  DELETE_ACCOUNT      : 4
}

const CANCEL_RETRY_DELAY = 120000; // 2 mins

export default class AccountControls extends Component {
  componentDidMount() {
    this.confirmedCancel = true;
    this.cancellationTriggerTime = 0;
    this.subscriptionId = 0;
  }
  constructor(props) {
    super(props);
    this.state = {
      cancellationCompleted : false,
      cancellationFailed : false,
      cancellationConfirmed : false,
      requestedCancel : false,
      subscriptionCreated : false,
      subscriptionActive : this.props.profile.isSubscriptionActive
    }
  }

  requestCancellation() {
    if (!this.state.requestedCancel) {
      this.setState({requestedCancel : true,
                     cancellationCompleted : false,
                     cancellationFailed : false,
                     cancellationConfirmed : false});
    }
  }

  confirmCancellation() {
    const currTime = new Date().getTime();
    if (!this.state.cancellationConfirmed && this.cancellationTriggerTime + CANCEL_RETRY_DELAY <= currTime) {
      this.cancellationTriggerTime = new Date().getTime();
      this.setState({cancellationConfirmed : true});
      fetch('https://cwcreations.net/php/cwblackjackacc/cancel_agreement.php')
        .then((res) => res.json())
        .then((data) => {
          let code = data.code;
          if (code === -2) {
            window.location.replace("/manage-cwgames-account");
          } else if (code === -1) {
            this.setState({cancellationFailed : true,requestedCancel : false});
          } else if (code === 0) {
            this.setState({cancellationCompleted : true,requestedCancel : false});
          }
        });
    } else {
      this.setState({cancellationFailed : true,requestedCancel : false});
    }
  }

  cancelCancellation() {
    this.setState({requestedCancel : false});
  }

  showCancellationPrompt() {
    if (this.state.cancellationCompleted) {
        return (<div><p className='cancellationText'>Cancellation completed.</p></div>);
      } 
    if (this.state.cancellationFailed) {
      return (<div><p className='cancellationText'>Server gave bad response. Try again soon</p></div>);
    }

    if (this.state.requestedCancel) {
      if (this.state.cancellationConfirmed) {
        return (<div><p className='cancellationText'>Processing your cancellation..</p></div>);
      }
      if (this.state.subscriptionActive) {
        setTimeout(() => {
          window.scrollTo(0, document.body.scrollHeight);
        },0);
        return (<div style={{'marginTop':'150px','marginLeft':'2vw','textAlign':'center'}}><h3><u>Do you really want to cancel your subscription?</u></h3><p className='cancellationText'>If cancelled, you can still enjoy the benefits until expiration.</p><div style={{'display':'flex','columnGap':'30px'}}><button className='accountManageButton' onClick={this.confirmCancellation.bind(this)}>Confirm cancellation</button><button className='accountManageButton' onClick={this.cancelCancellation.bind(this)}>Do not cancel</button></div></div>)
      }
      return (<div><p className='cancellationText'>You do not have an active subscription.</p></div>);
    }
    return (<div></div>);
  }
  
  onApproveOrder = (data,actions) => {
    this.subscriptionId = data.subscriptionID;
    this.setState({subscriptionCreated : true});
    fetch('https://cwcreations.net/php/cwblackjackacc/logout.php');
  }

  getMembershipContent() {
    const unsubsribedControls = (<div><h3 style={{'backgroundColor':'#d3c772','padding':'5px'}}>PREMIUM MEMBERSHIP $5 USD/m </h3><PaypalModule props={this.props.profile.playerId} errored={this.props.profile.isPaypalError} onApprove={this.onApproveOrder.bind(this)}></PaypalModule></div>);
    const subscribedControls = 
      (<div>
        <h3 style={{'backgroundColor':'#d3c772','padding':'5px','marginBottom':'30px','marginRight':'20%'}}>PREMIUM MEMBERSHIP ACTIONS</h3>
        <div style={{'display':'flex','flexDirection':'row','columnGap':'30px','marginTop':'0px'}}>
          <Link to='https://cwblackjack.cwcreations.net'><button className='accountManageButton' style={{'opacity':this.state.requestedCancel? .5 : 1}}>Play now</button></Link><Link to="/explore-premium"><button  style={{'opacity':this.state.requestedCancel? .5 : 1}} className='accountManageButton'>View benefits</button></Link>
          <Link><button className='accountManageButton' style={{'opacity':'.75'}} onClick={this.requestCancellation.bind(this)}>Cancel benefits</button></Link>
        </div>
        {this.showCancellationPrompt()}
      </div>);
    const subscriptionConfirmation = (<div><h3 style={{'backgroundColor':'#d3c772','padding':'5px'}}>Thank you for your purchase.</h3><p>If you're already logged into the game, you must relogin for your membership to activate.</p><p style={{'whiteSpace':'nowrap'}}>Your PayPal subscription ID is {this.subscriptionId}</p></div>);
          
    if (this.state.subscriptionCreated) {
      return subscriptionConfirmation;
    }
    if (this.props.profile.isPremium) {
      return subscribedControls;
    }
    return unsubsribedControls;
  }

  getContentWidth() {
    if (this.state.subscriptionCreated || this.props.profile.isPremium) {
      return '80%';
    }
    return '50%';
  }

  
//<PaypalModule props={this.props}/>
  render() {
    return (<div id='AccountControls' style={{'width':this.getContentWidth()}}>{this.getMembershipContent()}</div>);
  }
  
  //<button>Update Preferences</button><button>Manage Subscription</button><button>Become a Premium User</button><button>Delete Account</button>
}